import classNames from 'classnames';
import {Typography} from 'components/Typography';
import {IEventsCalendarItem} from 'modules/events/helpers/calendar';
import {FC} from 'react';
import style from './style.module.scss';

interface IProps {
    data: IEventsCalendarItem;
    disabled?: boolean;
    isActive: boolean;
    onSelectDay: (data: IEventsCalendarItem) => void;
}

export const CalendarSliderItem: FC<IProps> = ({data, disabled, isActive, onSelectDay}) => {
    const {day, dayOfWeek, isStartOfMonth, isWeekend, month} = data;

    const handleClick = () => {
        onSelectDay(data);
    };

    return (
        <div
            className={classNames(style.main, {
                [style.isWeekend]: isWeekend,
                [style.isStartOfMonth]: isStartOfMonth,
                [style.isActive]: isActive,
                [style.disabled]: disabled,
            })}
        >
            <Typography className={style.month} variant={'ch-title-16-r'}>
                {month}
            </Typography>
            <button className={style.button} onClick={handleClick} type={'button'}>
                <Typography variant={'ch-title-20-b'}>{day}</Typography>
                <Typography className={style.dayOfWeek} variant={'label-10-b'}>
                    {dayOfWeek}
                </Typography>
            </button>
        </div>
    );
};
